import { useEffect } from "react";
import PostList from "../components/PostList";
import BaseContainer from "../containers/BaseContainer";

export default function BlogListPage() {
  useEffect(() => {
    document.title = "Articles | Matteo Aries";
  }, []);

  return (
    <BaseContainer>
      <div className="mb-10">
        <h1 className="text-4xl font-black uppercase tracking-tight">
          Articles
          <span className="text-orange-600">.</span>
        </h1>
        <div className="w-20 h-1 bg-black mt-2" />
      </div>
      <PostList />
    </BaseContainer>
  );
}
